import { useLayoutEffect, useRef, useState } from 'react';

// Port of src/app/shared/components/loading/result-skeleton/ (mypart-result-skeleton).
// Template copied verbatim (commented-out SVG blocks in the Angular template dropped).
// The Angular .scss file was empty.
//
// Behavior (mirrored):
// - width starts at 300, measured from the host element's offsetWidth after view
//   init; the image block's height is bound to (width - 16)px.
// - Re-measured on window resize, with the directive's 100ms timeout, using a
//   capture-phase listener (addEventListener(..., true)). Unlike the Angular
//   component (which never removed its listener), the listener and timer are
//   cleaned up on unmount.
// - The Angular class also computed `height = width + width / 2`, but it was
//   never used in the template, so it is not ported.

export default function ResultSkeleton() {
  const rootRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(300);

  useLayoutEffect(() => {
    const checkWidth = () => {
      if (rootRef.current) {
        setWidth(rootRef.current.offsetWidth);
      }
    };

    checkWidth();

    let timer = 0;
    const onResize = () => {
      // timeout is needed to initialize el element
      timer = window.setTimeout(checkWidth, 100);
    };
    window.addEventListener('resize', onResize, true);

    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('resize', onResize, true);
    };
  }, []);

  return (
    <div
        ref={rootRef}
        className="animate-pulse sm:max-w-sm shadow hover:shadow-md rounded dark:bg-zinc-900 hover:shadow-red-950-md p-2 sm:p-0"
        role="status">
      <div style={{ height: width - 16 + 'px' }}
           className="relative flex shadow-xl items-center justify-center mb-4 bg-gray-300 dark:bg-gray-700">
      </div>

      <div className="flex items-center justify-between mt-4 space-x-3">
        <div>
          <div className="h-2 sm:h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-24 sm:w-48 mb-4"></div>
          <div className="w-16 sm:w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>

        <div className="hidden md:block h-[48px] w-[48px] bg-gray-300 rounded dark:bg-gray-700"></div>
      </div>
      <span className="sr-only">Loading...</span>
    </div>
  );
}
